import { z } from 'zod';
import { DEFAULT_LIMIT, MAX_LIMIT, MAX_BULK_ITEMS } from '../pagination';
/** 文字数上限（docs/02-functional-spec.md 0.1） */
export const LIMITS = {
    subject: 200,
    /** 件名の推奨上限。文面生成の制約は generate 側で 40 に絞る */
    body: 10_000,
    note: 5_000,
    tag: 30,
    name: 200,
    url: 2_000,
    reason: 500,
};
export const uuid = z.string().uuid({ message: 'ID の形式が正しくありません' });
export const idParam = z.object({ id: uuid });
export const trimmed = (max, message) => z.string().trim().min(1, message ?? '入力してください').max(max, `${max} 文字以内で入力してください`);
export const optionalTrimmed = (max) => z
    .string()
    .trim()
    .max(max, `${max} 文字以内で入力してください`)
    .optional()
    .transform((v) => (v === '' ? undefined : v));
/** `a,b,c` 形式のクエリを配列にする */
export const csvArray = (item) => z
    .union([z.string(), z.array(z.string())])
    .optional()
    .transform((v) => {
    if (v == null)
        return undefined;
    const parts = Array.isArray(v) ? v : v.split(',');
    return parts.map((p) => p.trim()).filter(Boolean);
})
    .pipe(z.array(item).optional());
export const boolQuery = z
    .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
    .optional()
    .transform((v) => (v == null ? undefined : v === true || v === 'true' || v === '1'));
export const intQuery = (min, max, fallback) => z
    .union([z.number(), z.string()])
    .optional()
    .transform((v) => {
    if (v == null || v === '')
        return fallback;
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isFinite(n) ? Math.min(Math.max(Math.trunc(n), min), max) : fallback;
});
export const dateQuery = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, '日付は YYYY-MM-DD の形式で指定してください')
    .optional();
/** 共通クエリパラメータ（docs/05-api-spec.md 1.4） */
export const listQuerySchema = z.object({
    cursor: z.string().max(1000).optional(),
    limit: intQuery(1, MAX_LIMIT, DEFAULT_LIMIT),
    sort: z.string().max(60).optional(),
    q: z.string().trim().max(200).optional(),
});
/** 一括操作の対象指定。ID 配列または絞り込み条件のどちらか */
export const bulkSelectionSchema = z
    .object({
    companyIds: z.array(uuid).max(MAX_BULK_ITEMS).optional(),
    filter: z.record(z.string(), z.unknown()).optional(),
})
    .refine((v) => (v.companyIds?.length ?? 0) > 0 || v.filter != null, {
    message: '対象を選択してください',
});
export const bulkResultSchema = z.object({
    requested: z.number().int(),
    applied: z.number().int(),
    skipped: z.number().int(),
    reasons: z.record(z.string(), z.number().int()).optional(),
});
export const acceptedJobSchema = z.object({
    jobRunId: uuid,
    status: z.string(),
});
//# sourceMappingURL=common.js.map